import { applicationFeesApi } from 'app/services/api';

import { LOAN_APPLICATION_ACTION_NAME_PREFIX } from 'constants/loanApplication';
import { catchAsyncActionError } from 'utils/action';
import { createNamedActions } from 'utils/namedActionTypesProxy';

export const LOAN_FEE_REASON_HISTORY_ACTION_TYPE = createNamedActions(
  `${LOAN_APPLICATION_ACTION_NAME_PREFIX}/feeReasonHistory`,
  {
    GET_LOAN_FEE_REASON_HISTORY: 'GET_LOAN_FEE_REASON_HISTORY',
    EDIT_LOAN_FEE_REASON_HISTORY: 'EDIT_LOAN_FEE_REASON_HISTORY',
  },
);

export const getLoanFeeReasonHistoryAction = catchAsyncActionError(params => async dispatch => {
  const { data } = await applicationFeesApi.getLoanFeesReasonsHistory(params);

  return dispatch({
    type: LOAN_FEE_REASON_HISTORY_ACTION_TYPE.GET_LOAN_FEE_REASON_HISTORY,
    payload: data,
  });
});

export const editLoanFeeReasonHistoryAction = params => async dispatch => {
  const { data } = await applicationFeesApi.editLoanFeesReasonsHistory(params);

  return dispatch({
    type: LOAN_FEE_REASON_HISTORY_ACTION_TYPE.EDIT_LOAN_FEE_REASON_HISTORY,
    payload: data,
  });
};
